import React, { useEffect, useState } from "react";
import { Col, Row, Card } from "react-bootstrap";
import Layout from "../Components/Website/Layout";
import "../layout/WhyChooseOurPlatform.css";
import axios from "axios";
import { baseURL } from "../API/API";
import { 
  FaBookOpen, 
  FaPenNib, 
  FaUsers, 
  FaUserGraduate, 
  FaHeadset, 
  FaGift 
} from "react-icons/fa";

// CSS/SVG Laptop Illustration component
const LaptopIllustration = ({ icon, screenText }) => {
  return (
    <div className="laptop-illustration">
      {/* Laptop Screen */}
      <div className="laptop-screen">
        <span className="screen-text">{screenText}</span>
      </div>
      {/* Laptop Base/Keyboard */}
      <div className="laptop-base"></div>
      {/* Central White Circle Overlay with Icon */}
      <div className="laptop-icon-circle">
        {icon}
      </div>
    </div>
  );
};

export default function WhyChooseOurPlatform() {
  const [supportPhone, setSupportPhone] = useState("01031360031");

  useEffect(() => {
    axios.get(`${baseURL}/learning/settings`)
      .then(res => {
        if (res.data?.data?.support_phone) {
          setSupportPhone(res.data.data.support_phone);
        }
      })
      .catch(err => console.log(err));
  }, []);

  const cards = [
    {
      number: 1,
      icon: <FaBookOpen />,
      title: "الشرح التفصيلي العميق",
      screenText: "خرائط ذهنية وتأسيس",
      description: "لكل جزئية في المناهج الدراسية بطريقة مبسطة تعتمد على الخرائط الذهنية وتأصيل المفاهيم الأساسية لكل مادة.",
    },
    {
      number: 2,
      icon: <FaPenNib />,
      title: "الحل المكثف وبنك الأسئلة",
      screenText: "بنك أسئلة وامتحانات",
      description: "بنك أسئلة عملاق على كل جزئية في المنهج بأفكار متدرجة تراعي كل المستويات، بالإضافة لامتحانات دورية شاملة.",
    },
    {
      number: 3,
      icon: <FaUsers />,
      title: "مساعدون متخصصون للمتابعة",
      screenText: "متابعة واستفسارات",
      description: "جروبات تليجرام وواتساب تفاعلية تحت إشراف نخبة من المساعدين المتخصصين للإجابة عن كافة استفساراتك وأسئلتك فوراً.",
    },
    {
      number: 4,
      icon: <FaUserGraduate />,
      title: "المتابعة الدورية الشاملة",
      screenText: "تقارير أداء دورية",
      description: "تقارير أداء دورية تُرسل للطالب وولي الأمر لضمان بقائه في قمة مستواه الدراسي والوقوف على نقاط قوته.",
    },
    {
      number: 5,
      icon: <FaHeadset />,
      title: "الدعم الأكاديمي والفني الفوري",
      screenText: "دعم فني وأكاديمي",
      description: `مشكلتك بتتحل في لحظتها، تواصل معنا فوراً على التليجرام أو الواتساب على الرقم ${supportPhone} وسنتولى الباقي.`,
    },
    {
      number: 6,
      icon: <FaGift />,
      title: "جوائز وهدايا تحفيزية قيمة",
      screenText: "جوائز وتحفيز مستمر",
      description: "هنافس عليها طول الوقت مع زملائك مثل رحلات العمرة، أجهزة اللاب توب، الهواتف الذكية والجوائز النقدية.",
    },
  ];

  return (
    <div className="why-choose-our-platform py-5">
      <Layout dir="rtl">
        <div className="section-title-wrapper text-center mb-5">
          <h2 className="section-title text-3xl font-bold">ليه تختار منصة نوح التعليمية؟</h2>
        </div>
 
        <Row className="g-4 items-section justify-content-center">
          {cards.map((card, idx) => (
            <Col key={idx} xs={12} md={6} lg={4} className="d-flex">
              <Card className="why-card-custom w-100 text-center d-flex flex-column align-items-center position-relative">
                {/* Number in the top-right corner of the card */}
                <div className="card-number-badge">{card.number}</div>
                
                {/* Laptop Illustration */}
                <div className="mb-3 mt-2">
                  <LaptopIllustration icon={card.icon} screenText={card.screenText} />
                </div>
                
                <Card.Body className="d-flex flex-column p-0 mt-2">
                  <Card.Title className="why-card-title-custom mb-3">{card.title}</Card.Title>
                  <Card.Text className="why-card-desc-custom flex-grow-1">
                    {card.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Layout>
    </div>
  );
}
